<input #inputElement type="text" 
[disabled]="disabled" [readOnly]="isReadonly" [attr.placeholder]="placeholder"
(input)="onInput($event)" (focus)="onFocusIn()" (blur)="onFocusOut()" (keydown)="onKeyDown($event)">
